import Helpers from "@common/helpers/helperFunctions";
import {
  SET_TERMINAL_AUTH_DATA,
  SET_TERMINAL_BALANCE,
  SET_POPUP_LAUNCHER,
  SET_MERCHANT_ID,
  SHOW_KEYBOARD,
  SET_DEPOSIT_BALANCE,
  SET_TERMINAL_SUPERBET_DATA,
  TOGGLE_ADMIN_PAGE_BLOCK_STATUS,
  SET_TERMINAL_ACUMULATOR_BONUSE,
  RESET_VERIFICATION_SESSION,
  SET_STARTUP_SETTINGS,
  SET_VERIFICATION_INFO,
  SHOW_LAST_BETS_LIST,
  CLEAR_LAST_BETS_LIST,
  IS_ADMIN_LOGGED_IN,
  IS_CARD_REGISTERED,
  CLEAR_CARD_REGISTERED,
  LOYAL_CARD,
  SET_LOYAL_CARD_INPUT_ACTIVE,
  SET_PLAYER_PAYMENT_INFO,
  SET_TERMINAL_DEPOSIT_MODE,
  RESET_PLAYER_PAYMENT_INFO,
  SET_PROFIT_BOOST_INFO,
  RECEIVE_SAVED_PLAYER_PAYMENT_INFO,
  SET_TERMINAL_USAGE_CONFIRMED,
} from "../actions/actionTypes";
import Config from "@skin_config";
import { TerminalDepositModesEnum } from "../constants/enums/terminalDepositModes";
import { isMultiDepositModeEnabled } from "../helpers/multiDepositMode";

const verificationInitalState = {
  isVerified: false,
  info: {},
};

const initStore = {
  startupSettings: {
    MinBet: 0,
    MaxBet: null,
    MinimalOdd: 0,
    HideLogo: false,
    TerminalName: "",
    BetshopName: "",
    IsPlayerVerificationEnabled: false,
  },
  superbetData: {},
  profitBoostPercent: null,
  profitBoostStake: null,
  loyalCard: {},
  depositMode: isMultiDepositModeEnabled() ? TerminalDepositModesEnum.Ticket : TerminalDepositModesEnum.Cash,
  playerInfo: {},
  savedPlayerInfo: null,
  showLastBetsList: [],
  isCardRegistered: {},
  isLoyalCardInputActive: false,
  verification: verificationInitalState,
  isAdminPageBlocked: false,
  merchantId: null,
  terminalUsageConfirmed: false,
};

const reducerTerminal = (state = initStore, action) => {
  switch (action.type) {
    case SET_MERCHANT_ID:
      return {
        ...state,
        merchantId: action.payload,
      };
    case SET_PROFIT_BOOST_INFO:
      return {
        ...state,
        profitBoostPercent: action.payload.percent,
        profitBoostStake: action.payload.stake
      }
    case RECEIVE_SAVED_PLAYER_PAYMENT_INFO:
      return {
        ...state,
        savedPlayerInfo: action.payload,
      };
    case TOGGLE_ADMIN_PAGE_BLOCK_STATUS:
      return {
        ...state,
        isAdminPageBlocked: action.payload,
      };
    case SET_TERMINAL_SUPERBET_DATA:
      return {
        ...state,
        superbetData: action.payload,
      };
    case RESET_PLAYER_PAYMENT_INFO:
      return {
        ...state,
        playerInfo: {},
      };
    case SET_PLAYER_PAYMENT_INFO:
      return {
        ...state,
        playerInfo: action.payload || {},
      };
    case SET_TERMINAL_AUTH_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case SET_TERMINAL_USAGE_CONFIRMED:
      return {
        ...state,
        terminalUsageConfirmed: action.payload,
      };
    case SET_TERMINAL_DEPOSIT_MODE:
      return {
        ...state,
        depositMode: action.mode,
      };
    case SET_VERIFICATION_INFO:
      return {
        ...state,
        verification: {
          ...state.verification,
          isVerified: true,
          info: action.payload,
        },
      };
    case RESET_VERIFICATION_SESSION:
      return {
        ...state,
        verification: verificationInitalState,
      };
    case SET_LOYAL_CARD_INPUT_ACTIVE:
      return {
        ...state,
        isLoyalCardInputActive: action.isActive,
      };
    case SET_TERMINAL_BALANCE:
      return {
        ...state,
        balance: {
          ...action.payload,
        },
      };
    case LOYAL_CARD:
      return {
        ...state,
        loyalCard: {
          ...action.payload,
        },
      };
    case SET_STARTUP_SETTINGS: {
      return {
        ...state,
        startupSettings: {
          ...action.payload,
        },
      };
    }
    case SET_TERMINAL_ACUMULATOR_BONUSE: {
      return {
        ...state,
        bonuses: action.payload,
      };
    }
    case IS_ADMIN_LOGGED_IN:
      return {
        ...state,
        isAdminLoggedIn: action.payload,
      };
    case IS_CARD_REGISTERED:
      return {
        ...state,
        isCardRegistered: action.payload,
      };
    case CLEAR_CARD_REGISTERED:
      return {
        ...state,
        isCardRegistered: {},
      };
    case SHOW_KEYBOARD:
      return {
        ...state,
        showKeyboard: action.payload,
      };
    case SHOW_LAST_BETS_LIST:
      return {
        ...state,
        showLastBetsList: action.payload,
      };
    case CLEAR_LAST_BETS_LIST:
      return {
        ...state,
        showLastBetsList: [],
      };
    case SET_POPUP_LAUNCHER:
      return {
        ...state,
        popupLauncher: action.payload,
      };
    case SET_DEPOSIT_BALANCE:
      return {
        ...state,
        balance: action.payload,
      };
    default:
      return state;
  }
};

export default reducerTerminal;
